import { buildBaseHeaders, handleUrl } from '../global';
import { DetailProps, RegisterPasswordData, SetupProps } from './types';

export const registerPassword = (
  token: string,
  data: RegisterPasswordData
): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);
  myHeaders.set('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(data),
  };
  const BaseUrl = handleUrl();
  return fetch(`${BaseUrl}/api/V1/companies/first-password`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const sendTokenPassword = (email: string): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
  };
  const BaseUrl = handleUrl();
  return fetch(
    `${BaseUrl}/api/V1/companies/first-password?email=${email}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const twoFaSend = ({
  token,
}: {
  token: string;
}): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);
  myHeaders.set('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/otp/send`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const twoFaEnable = ({
  code,
  token,
}: {
  code: string;
  token: string;
}): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);
  myHeaders.set('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify({ code }),
  };

  const BaseUrl = handleUrl();
  return fetch(`${BaseUrl}/api/V1/otp/enable`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const totpSetup = ({
  token,
}: {
  token: string;
}): Promise<SetupProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
  };
  const BaseUrl = handleUrl();
  return fetch(`${BaseUrl}/api/V1/totp/setup`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const totpEnable = ({
  code,
  token,
}: {
  code: string;
  token: string;
}): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);
  myHeaders.set('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify({ code }),
  };

  const BaseUrl = handleUrl();
  return fetch(`${BaseUrl}/api/V1/totp/enable`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
